<template>
  <div>
    <!-- UPLOADED DOCUMENTS -->
    <div>
      <p class="font-weight-medium text-left">View or Upload Documents</p>
      <v-form :disabled="is_terminated || !currentUser.privileges.canEditUploadedDocuments" v-model="uploadDocumentsForm">
        <v-container>
          <v-row v-for="doctype in doctypes" :key="doctype.id">
            <v-col cols="12" md="9" >
              <p v-if="!currentUser.privileges.canEditUploadedDocuments" class="red--text">You do not have enough permissions to upload documents</p>

              <v-file-input
                dense
                color="primary"
                counter
                :label="doctype.name"
                @change="onDocChange($event, doctype)"
                prepend-icon="mdi-paperclip"
                outlined
                class="rounded-input"
                :disabled="readonly"
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn class="ma-0" text color="primary" outlined dense :href="getDocument(doctype)" target="_blank" :disabled="!isDocumentAvailable(doctype)">
                View Document</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
    </div>
  </div>
</template>

<script>
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
import {mapActions, mapGetters} from "vuex";


export default {
  name: "UploadedDocumentsStepperContent",
  props: {
    doctypes: {
      default: () => [],
      type: Array,
    },
    admissionDocs: {
      default: () => [],
      type: Array,
    },
    is_terminated: {
      default: true,  
      type: Boolean,
    }, 
    is_from_portal: {
      default: false,
      type: Boolean,
    },
    is_editing: {
      default: false,
      type: Boolean,
    },
    readonly: {
      default: false,
      type: Boolean,
    },
    
    admission_id: null,
  },
  data(){
    return{
      documents: {},
      uploadDocumentsForm : true,
      snackbar: {
        visible: false,
        text: "",
      },
    };
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    isDocumentAvailable(doctype){
      if(!this.is_editing){
        return false;
      }
      var document = this.admissionDocs.find(x => x.doc_type.id == doctype.id);
      // console.log(document);
      if(document!=null){
        return true;
      }
      return false;
    },

    getDocument(doctype){
      var document = this.admissionDocs.find(x => x.doc_type.id == doctype.id);
      // console.log(document);
      if(document!=null){
        return document.document_file;
      }
      else{
        return "#";
      }
    },

    async onDocChange(payload, doctype){
      // this.setLoading(true);
      const file = payload; 
      if(file){
        this.documents[doctype.id] = await Helper.toBase64(file);
      }
      else{
        delete this.documents[doctype.id]
      }
      this.uploadDocumentsForm = true;
      // this.setLoading(false); 
    },

    // Do not TOUCH or change names 
    async saveFormDetails(){
      if(!this.uploadDocumentsForm){
        alert("Form Not Valid");
        return;
      }
      var url = endpoints.admissions + "application/documents/";
      var post_body = {
        has_documents: ((Object.keys(this.documents)).length > 0),
        is_editing: this.is_editing,
        admission_id: this.admission_id,
        documents: this.documents,
      };
      var response = await api.call(this.apiEssentials,url,api.Methods.POST, post_body);
      if (response instanceof Error){
        this.setLoading(false);
        this.snackbar.text = "Error saving details";
        this.snackbar.visible = true;
        return;
      }
      // this.$router.push({name: 'EditAdmissionDetails', params: { admission_id: response.id }});
      this.snackbar.text = "Successfully saved uploaded documents!";
      this.snackbar.visible = true;
      this.$emit("save-response",{ step: 3 ,name: 'admissionDetails', value: response});
      this.uploadDocumentsForm = false;
    },
  },
  watch: {
    // DO NOT TOUCH
    uploadDocumentsForm(){
      this.$emit("form-change",{ step: 3 ,name: 'uploadDocumentsForm', is_valid: this.uploadDocumentsForm});
    }
  },
  created(){
    this.$emit("form-change",{ step: 3 ,name: 'uploadDocumentsForm', is_valid: this.uploadDocumentsForm});
  }

};
</script>

<style>
</style>